import MemberAnnotationsApi from './annotations';
import MembersMeetingsApi from './meetings';

export default {
  annotations: new MemberAnnotationsApi(),
  meetings: new MembersMeetingsApi(),
};
